<template>
    <div>
        <div class="form-horizontal">

            <form-input :form="form" property="feature_id" label="Feature">
                <select3 :value="form.feature" @input="setFeature" allow-clear data-url="/api/features/features" value-key="name"></select3>
            </form-input>

            <form-input :form="form" property="name"></form-input>
            <form-input :form="form" property="subtitle"></form-input>

            <form-input :form="form" property="description">
                <textarea v-model="form.description" class="form-control" cols="10" rows="5"></textarea>
            </form-input>

            <form-input :form="form" property="image" label="Icon">
                <photo-upload @input="files.image = $event" :value="form.image.url" @clear="files.image = null; form.image = {url: ''}"></photo-upload>
            </form-input>

            <gallery-upload v-model="form.gallery" @change="files.gallery = $event"></gallery-upload>

            <form-input-trans :form="form" property="image.alt"></form-input-trans>

        </div>
    </div>
</template>


<script>
import Model from 'lib/Model';
import Form from 'lib/Form';
import UploadFiles from 'lib/UploadFiles';
import axios from 'axios';

export default {
    mixins: [Model, UploadFiles],
    data() {
        return {
            method: '/api/features/subfeatures',
            form: new Form(() => {
                return {
                    name: null,
                    subtitle: null,
                    feature:null,
                    feature_id:null,
                    description: null,
                    image: {
                        alt: {}
                    },
                    gallery: [],
                };
            }),
        };
    },
    mounted() {

    },
    methods: {
        setFeature: function(feature) {
            if (feature) {
                this.form.feature = feature;
                this.form.feature_id = feature.id;

            } else {
                this.form.feature = null;
                this.form.feature_id = null;
            }
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/forms/features/Subfeature.vue